import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/categories';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-col footer-brand">
          <div className="navbar-logo">Mis<span>XV</span><small>.com.mx</small></div>
          <p>El directorio y marketplace líder de proveedores para fiestas de XV años en México.</p>
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">Facebook</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">Instagram</a>
            <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" aria-label="TikTok">TikTok</a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Categorías</h4>
          <ul>
            {categories.slice(0, 6).map((c) => (
              <li key={c.slug}><Link to={`/categoria/${c.slug}`}>{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Empresa</h4>
          <ul>
            <li><Link to="/nosotros">¿Quiénes somos?</Link></li>
            <li><Link to="/blog">Blog e ideas</Link></li>
            <li><Link to="/anunciate">Anuncia tu negocio</Link></li>
            <li><Link to="/contacto">Contacto</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Cuenta</h4>
          <ul>
            <li><Link to="/login">Iniciar sesión</Link></li>
            <li><Link to="/registro">Crear cuenta</Link></li>
            <li><Link to="/favoritos">Mis favoritos</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {year} MisXV.com.mx — Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}
